export const appTranslations = {
  en: {
    home: 'Home',
    ourEssence: 'Our Essence',
    menu: 'Menu',
    ambience: 'Ambience',
    gallery: 'Gallery',
    contact: 'Contact',
    heroTitle: 'Experience the Soul of Latin America',
    heroSubtitle: 'Authentic flavors, vibrant music, and an unforgettable atmosphere.',
    discoverMore: 'Discover More',
    essenceTitle: 'Our Essence',
    essenceParagraph1: 'At El Latino, we believe in more than just serving coffee; we offer an experience. Our space is a vibrant tapestry woven with the rich colors, sounds, and flavors of Latin America. From the moment you step in, you are transported to a world where every sip and every bite tells a story.',
    essenceParagraph2: 'We source the finest beans and ingredients, ensuring that each dish and drink is a celebration of authentic culinary traditions. Our passion for quality and culture is evident in every detail, creating an atmosphere that is both lively and welcoming.',
    learnMore: 'Learn More',
    menuTitle: 'Our Menu',
    menuDescription: 'Explore our delicious offerings. Click the image to zoom in!',
    viewMenu: 'View Menu',
    viewMenu: 'View Menu',
    hideMenu: 'Hide Menu',
    closeMenu: 'Close Menu',
    previous: 'Previous',
    next: 'Next',
    page: 'Page',
    of: 'of',
    pdfError: 'Error loading the menu. Please try again later.',
    ambienceTitle: 'Our Ambience',
    ambienceParagraph1: 'Step into El Latino and immerse yourself in an atmosphere designed to delight your senses. Our decor blends rustic charm with modern elegance, featuring vibrant murals, comfortable seating, and warm lighting that invites you to relax and linger.',
    ambienceParagraph2: 'The air is filled with the rhythmic sounds of Latin music, creating a lively backdrop for conversations and connections. Whether you are here for a quick coffee, a leisurely meal, or a vibrant evening, our ambience ensures a memorable visit.',
    exploreSpace: 'Explore Our Space',
    galleryTitle: 'Gallery',
    contactTitle: 'Contact Us',
    contactName: 'Name',
    contactNamePlaceholder: 'Your Name',
    contactEmail: 'Email',
    contactEmailPlaceholder: 'Your Email',
    contactMessage: 'Message',
    contactMessagePlaceholder: 'Your Message',
    contactSend: 'Send Message',
    allRightsReserved: 'All rights reserved.',
  },
  gr: {
    home: 'Αρχική',
    ourEssence: 'Η Ουσία μας',
    menu: 'Μενού',
    ambience: 'Ατμόσφαιρα',
    gallery: 'Συλλογή',
    contact: 'Επικοινωνία',
    heroTitle: 'Ζήστε την Ψυχή της Λατινικής Αμερικής',
    heroSubtitle: 'Αυθεντικές γεύσεις, ζωντανή μουσική και μια αξέχαστη ατμόσφαιρα.',
    discoverMore: 'Ανακαλύψτε Περισσότερα',
    essenceTitle: 'Η Ουσία μας',
    essenceParagraph1: 'Στο El Latino, πιστεύουμε σε κάτι περισσότερο από το σερβίρισμα καφέ. Προσφέρουμε μια εμπειρία. Ο χώρος μας είναι μια ζωντανή ταπετσαρία υφασμένη με τα πλούσια χρώματα, τους ήχους και τις γεύσεις της Λατινικής Αμερικής. Από τη στιγμή που θα μπείτε, μεταφέρεστε σε έναν κόσμο όπου κάθε γουλιά και κάθε μπουκιά αφηγείται μια ιστορία.',
    essenceParagraph2: 'Προμηθευόμαστε τους καλύτερους κόκκους και συστατικά, διασφαλίζοντας ότι κάθε πιάτο και ποτό είναι μια γιορτή αυθεντικών γαστρονομικών παραδόσεων. Το πάθος μας για την ποιότητα και τον πολιτισμό είναι εμφανές σε κάθε λεπτομέρεια, δημιουργώντας μια ατμόσφαιρα που είναι τόσο ζωντανή όσο και φιλόξενη.',
    learnMore: 'Μάθετε Περισσότερα',
    menuTitle: 'Το Μενού μας',
    menuDescription: 'Εξερευνήστε τις νόστιμες προσφορές μας. Κάντε κλικ στην εικόνα για μεγέθυνση!',
    viewMenu: 'Δείτε το Μενού',
    viewMenu: 'Δείτε το Μενού',
    hideMenu: 'Απόκρυψη Μενού',
    closeMenu: 'Κλείσιμο Μενού',
    previous: 'Προηγούμενο',
    next: 'Επόμενο',
    page: 'Σελίδα',
    of: 'από',
    pdfError: 'Σφάμμα φόρτωσης του μενιού. Παρακαλώ δοκιμάστε ξανά αργότερα.',
    ambienceTitle: 'Η Ατμόσφαιρά μας',
    ambienceParagraph1: 'Μπείτε στο El Latino και βυθιστείτε σε μια ατμόσφαιρα σχεδιασμένη να ευχαριστεί τις αισθήσεις σας. Η διακόσμησή μας συνδυάζει τη ρουστίκ γοητεία με τη μοντέρνα κομψότητα, με ζωντανές τοιχογραφίες, άνετα καθίσματα και ζεστό φωτισμό που σας προσκαλεί να χαλαρώσετε και να παραμείνετε.',
    ambienceParagraph2: 'Ο αέρας είναι γεμάτος με τους ρυθμικούς ήχους της λατινικής μουσικής, δημιουργώντας ένα ζωντανό σκηνικό για συζητήσεις και συνδέσεις. Είτε είστε εδώ για έναν γρήγορο καφέ, ένα χαλαρό γεύμα ή μια ζωντανή βραδιά, η ατμόσφαιρά μας εξασφαλίζει μια αξέχαστη επίσκεψη.',
    exploreSpace: 'Εξερευνήστε τον Χώρο μας',
    galleryTitle: 'Συλλογή',
    contactTitle: 'Επικοινωνία',
    contactName: 'Όνομα',
    contactNamePlaceholder: 'Το Όνομά σας',
    contactEmail: 'Email',
    contactEmailPlaceholder: 'Το Email σας',
    contactMessage: 'Μήνυμα',
    contactMessagePlaceholder: 'Το Μήνυμά σας',
    contactSend: 'Στείλτε Μήνυμα',
    allRightsReserved: 'Όλα τα δικαιώματα διατηρούνται.',
  },
  es: {
    home: 'Inicio',
    ourEssence: 'Nuestra Esencia',
    menu: 'Menú',
    ambience: 'Ambiente',
    gallery: 'Galería',
    contact: 'Contacto',
    heroTitle: 'Experimenta el Alma de Latinoamérica',
    heroSubtitle: 'Sabores auténticos, música vibrante y una atmósfera inolvidable.',
    discoverMore: 'Descubre Más',
    essenceTitle: 'Nuestra Esencia',
    essenceParagraph1: 'En El Latino, creemos en algo más que servir café; ofrecemos una experiencia. Nuestro espacio es un vibrante tapiz tejido con los ricos colores, sonidos y sabores de América Latina. Desde el momento en que entras, te transportas a un mundo donde cada sorbo y cada bocado cuenta una historia.',
    essenceParagraph2: 'Obtenemos los mejores granos e ingredientes, asegurando que cada plato y bebida sea una celebración de las auténticas tradiciones culinarias. Nuestra pasión por la calidad y la cultura es evidente en cada detalle, creando una atmósfera que es a la vez animada y acogedora.',
    learnMore: 'Saber Más',
    menuTitle: 'Nuestro Menú',
    menuDescription: 'Explora nuestras deliciosas ofertas. ¡Haz clic en la imagen para hacer zoom!',
    viewMenu: 'Ver Menú',
    viewMenu: 'Ver Menú',
    hideMenu: 'Ocultar Menú',
    closeMenu: 'Cerrar Menú',
    previous: 'Anterior',
    next: 'Siguiente',
    page: 'Página',
    of: 'de',
    pdfError: 'Error al cargar el menú. Por favor, inténtelo de nuevo más tarde.',
    ambienceTitle: 'Nuestro Ambiente',
    ambienceParagraph1: 'Entra en El Latino y sumérgete en una atmósfera diseñada para deleitar tus sentidos. Nuestra decoración combina el encanto rústico con la elegancia moderna, con murales vibrantes, asientos cómodos e iluminación cálida que te invita a relajarte y quedarte.',
    ambienceParagraph2: 'El aire se llena con los sonidos rítmicos de la música latina, creando un telón de fondo animado para conversaciones y conexiones. Ya sea que estés aquí para un café rápido, una comida tranquila o una noche vibrante, nuestro ambiente garantiza una visita memorable.',
    exploreSpace: 'Explora Nuestro Espacio',
    galleryTitle: 'Galería',
    contactTitle: 'Contáctanos',
    contactName: 'Nombre',
    contactNamePlaceholder: 'Tu Nombre',
    contactEmail: 'Correo Electrónico',
    contactEmailPlaceholder: 'Tu Correo Electrónico',
    contactMessage: 'Mensaje',
    contactMessagePlaceholder: 'Tu Mensaje',
    contactSend: 'Enviar Mensaje',
    allRightsReserved: 'Todos los derechos reservados.',
  },
};